import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentGql } from './FlowsDisplayGridRowDataFragmentGql';

export const LensUpstreamFlowsQueryGql: DocumentNode = gql`
query LensUpstreamFlowsQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  lenses(filter: { vizportalUrlId: $vizportalUrlId }) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragment
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentGql}
`;
